import { useMutation, useQuery } from '@tanstack/react-query'

import { TeamRole } from '@pkg/types/team'

import api from '@/api'
import { queryClient } from '@/react-query/client'
import { TEAM_BILLING_KEY, TEAM_KEY } from '@/react-query/team'

export const TEAM_MATES_KEY = 'teamMembers'
export const UPDATE_TEAM_MEMBER_ROLE_KEY = 'updateTeamMemberRole'

export const useTeamMembers = () => {
  return useQuery({
    queryKey: [TEAM_MATES_KEY],
    queryFn: async () => (await api.getTeamMembers()).data.teamMembers,
  })
}

export const useRemoveTeamMember = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      return await api.removeTeamMember({
        email,
      })
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [TEAM_MATES_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [TEAM_BILLING_KEY],
      })
    },
  })
}

export const useUpdateTeamMemberRole = () => {
  return useMutation({
    mutationKey: [UPDATE_TEAM_MEMBER_ROLE_KEY],
    mutationFn: async (data: { email: string; newRole: TeamRole }) => {
      return await api.updateTeamMemberRole(data)
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: [TEAM_MATES_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [TEAM_BILLING_KEY],
        }),
        queryClient.invalidateQueries({
          queryKey: [TEAM_KEY],
        }),
      ])
    },
  })
}
